import cs from './translation.cs.json';
import de from './translation.de.json';
import el from './translation.el.json';
import en from './translation.en.json';
import es from './translation.es.json';
import hu from './translation.hu.json';
import sk from './translation.sk.json';
export var Languages = [
    { code: "cs", label: "Czech", resource: cs },
    { code: "de", label: "German", resource: de },
    { code: "el", label: "Greek", resource: el },
    { code: "en", label: "English", resource: en },
    { code: "es", label: "Spanish", resource: es },
    { code: "hu", label: "Hungarian", resource: hu },
    { code: "sk", label: "Slovak", resource: sk },
];
